import { render, staticRenderFns } from "./SocialMediaButton.vue?vue&type=template&id=d30754c2&scoped=true&"
import script from "./SocialMediaButton.vue?vue&type=script&lang=ts&"
export * from "./SocialMediaButton.vue?vue&type=script&lang=ts&"
import style0 from "./SocialMediaButton.vue?vue&type=style&index=0&id=d30754c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d30754c2",
  null
  
)

export default component.exports